import { FAILED, LOADING, SUCCESS, ACTION, RESET, RESET_ALL } from './constants';

export const initialState = {
//   customerSubmissionUnblock: {
  dataCustomerUnblock: null,
  dataCustomerUnblockOnProcess: null,
  dataDetailCustomerUnblock: null,
  dataHistoryBlock: [],
  dataSummary: {
    needVerification: 0
  },
  dataUnblockSubmission: null,
  isLoadingCustomerProcessed: false,
  isLoadingCustomerUnblockOnProcess: false,
  isLoadingDetailCustomerUnblock: false,
  isLoadingHistoryBlock: false,
  messageCustomerUnblock: null,
  meta: {
    page: 1,
    totalPage: 1,
    totalData: 0,
  },
//   },
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;
  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case ACTION:
      return {
        ...state,
        action: data,
      };
    case RESET:
      return{
        ...state,
        [key]: null
      };
    case RESET_ALL:
      return initialState;
    default:
      return state;
  }
}
